export default __webpack_public_path__ + "static/media/sandakan.1c6055ed.png";